/***
 *
 * @file actions/dynamicPage.ts
 * @description dynamicPage actions will be used for API calls and logic.
 * @author Naveen Kumar
 * @organization Ingka Centres
 * @since 13 Feb 2024
 *
 */

import { DEFAULT_PAGE_CONTENT_TYPE, DEFAULT_PAGE_TAG } from '@/config/app.config';
import { API } from '@/services/api.service';
import { T_DataRequestProps, T_KeyValue } from '@/types/app.type';

/**
 * Contains the API response data
 */
type T_ResData = {
    /** unique id of the response */
    id: number
}

/**
 * Name: getStruct
 * 
 * Description: makes an API call to fetch the structure of content type = "baseplateLandingPageOne" in Contentful
 * 
 * @returns {object} API response of the structure of content type
 */
export const getPageStruct = async ({ contentType = DEFAULT_PAGE_CONTENT_TYPE, preview = false }: T_DataRequestProps) => {
    // const { message, struct }: any = await API.getContentType({ pathParams: ['baseplatePage'], preview: false });
    const { message, struct }: any = await API.getContentType({ pathParams: typeof (contentType) === "string" ? contentType?.split(',') : contentType, preview: preview });
    return struct;
}

/**
 * Name: getData
 * 
 * Description: makes an API call to fetch the contents with tag = "baseplate,baseplateDemoPage" from Contentful
 * 
 * @returns {object} API response from Contentful 
 */
export const getData = async ({id, slug, tags = DEFAULT_PAGE_TAG, contentType, preview = false, locale }: T_DataRequestProps): Promise<object> => {
    // console.log("get data ---- ", "slug: ", slug, " | tags: ", tags, " | contentType: ", contentType, " | preview: ", preview)
    // const { message, data } = await API.getContent({ queryParams: { "metadata.tags.sys.id[all]": "circuit,baseplateDemoPage", "include": 10 } });
    // const { message, data } = await API.getContent({ queryParams: { "metadata.tags.sys.id[all]": `${tags}`, "include": 10 }, preview: preview });
    const { message, data } = await API.getContent({ 
        ...(id ? {pathParams: [id]} : {}),
        queryParams: { 
            ...(()=>{
                let query: T_KeyValue = {};
                if(contentType) {
                    query["content_type"] = contentType
                }
                if(slug) {
                    query["fields.slug"] = slug
                } else if(tags) {
                    query["metadata.tags.sys.id[all]"] = tags
                }
                if(locale) {
                    query["locale"] = locale
                }
                return query;
            })(), 
            "include": 10 
        }, 
        preview: preview 
    }) || { message: "Time out...", data: {} };

    return data as object;
}


export const getActData = async ({ slug, tags = DEFAULT_PAGE_TAG, contentType, preview = false, locale }: T_DataRequestProps) => {
    // console.log("get data ---- ", "slug: ", slug, " | tags: ", tags, " | contentType: ", contentType, " | preview: ", preview)
    // const { message, data } = await API.getContent({ queryParams: { "metadata.tags.sys.id[all]": "circuit,baseplateDemoPage", "include": 10 } });
    // const { message, data } = await API.getContent({ queryParams: { "metadata.tags.sys.id[all]": `${tags}`, "include": 10 }, preview: preview });
    const { res }: any = await API.getActualContent({ 
        queryParams: { 
            ...(()=>{
                let query: T_KeyValue = {};
                if(contentType) {
                    query["content_type"] = contentType
                }
                if(slug) {
                    query["fields.slug"] = slug
                } else if(tags) {
                    query["metadata.tags.sys.id[all]"] = tags
                }
                if(locale) {
                    query["locale"] = locale
                }
                return query;
            })(), 
            "include": 10 
        }, 
        preview: preview 
    }) || { message: "Time out...", res: {} };

    return res;
}